<template>
    <div>
      <p>Upload files for transcription in one of the supported formats. <b-icon icon="question-square" v-b-toggle="'collapse-1'"></b-icon></p>

      <div>
          <b-collapse id="collapse-1" v-model="helpVisible" class="py-3">
              <li><code>.mp3</code> audio/mpeg</li>
              <li><code>.m4a</code> audio/m4a</li>
              <li><code>.ogg</code> audio/ogg.</li>
              <li><code>.flac</code> audio/x-flac.</li>
              <li><code>.wav</code> audio/x-wav, audio/wav.</li>
          </b-collapse>
          <p>You can also upload MP4 video or AAC file and it will automatically be transcoded before transcription.</p>
      </div>
       <b-row class="my-2">
         <b-col cols="4" md="4" class="text-center">
            <Multiselect
              v-model="transcribeModel"
              :options="transcribeModels"
              @input="fetchLexicons()"
              label="label"
              track-by="name"
              placeholder="Select the language model">
            </Multiselect>
        </b-col>
         <b-col v-if="this.lexiconListGenerated" cols="4" md="4" class="text-center">
            <Multiselect
              v-model="transcribeLexiconId"
              :options="transcribeLexiconModels"
              :group-select="false"
              :multiple="false"
              placeholder="Select lexicon build">
            </Multiselect>
        </b-col>
         <b-col cols="4" md="4" class="text-center">
            <Multiselect
              v-model="selectedOptions"
              :options="options"
              label="label"
              track-by="name"
              multiple
              placeholder="Optional features">
            </Multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <vue-dropzone
            :awss3="awss3"
            ref="myVueDropzone"
            id="dropzone"
            :options="dropzoneOptions"
            @vdropzone-s3-upload-error="s3UploadError"
            @vdropzone-s3-upload-success="s3UploadSuccess"
            @vdropzone-upload-progress="(file, progress, bytesSent) => uploadProgress(file, progress, bytesSent)"
            ></vue-dropzone>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-alert :show="alertVisible" :variant="alertType" dismissable class="mt-3">{{ alertText }}</b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button type="button"
                    variant="primary"
                    size="md"
                    class="mx-3 mt-3"
                    :disabled="disabledUploadButton"
                    @click.prevent="triggerSend()">
            TRANSCRIBE FILES
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-button type="button"
                    variant="warning"
                    size="md"
                    class="mx-3 mt-3"
                    @click.prevent="openFTPDialog()">
            FTP Downloader
          </b-button>

          <b-button type="button"
                    variant="danger"
                    size="md"
                    class="mx-3 mt-3"
                    @click.prevent="openS3Dialog()">
            S3 Downloader
          </b-button>
        </b-col>
      </b-row>
      <br />

      <b-row v-if="canOpenFTPDialog === false">
        <b-col cols="6" class="text-center text-light bg-dark">
          <div>
            <table class="table-striped">
              <thead>
                <tr>
                  <th scope="col" class="text-center"><u>Folder Name</u></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="folder in ftpDirectoryList" v-bind:key="folder">
                  <td>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder" viewBox="0 0 16 16">
                      <path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4H2.19zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"/>
                    </svg>
                    <span style="cursor: pointer;" @click.prevent="navigateFtpFolder(folder)">
                      {{ folder }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
        <b-col cols="6" class="text-center text-light bg-dark">
          <div>
            <table class="table-striped">
              <thead>
                <tr>
                  <th scope="col" class="text-center"><u>File Name</u></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="file in ftpFileList" v-bind:key="file">
                  <td>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-code" viewBox="0 0 16 16">
                      <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>
                      <path d="M8.646 6.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 9 8.646 7.354a.5.5 0 0 1 0-.708zm-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 9l1.647-1.646a.5.5 0 0 0 0-.708z"/>
                    </svg>
                    <span style="cursor: pointer;" @click.prevent="downloadFtpFile(file)">
                      {{ file }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="canOpenFTPDialog === true">
        <b-col cols="3" class="text-center text-light bg-dark">
          <div>
            <br />
            <form>
              <div class="form-group">
                <label>FTP Host</label>
                <input v-model="ftpFormHost" type="text" class="form-control" placeholder="Enter FTP host">
                <small class="form-text text-muted">The host of FTP server (Ex: 175.365.10.21 OR www.mywebsite.org</small>
              </div>
              <div class="form-group">
                <label>Username</label>
                <input v-model="ftpFormUsername" type="text" class="form-control" placeholder="Enter FTP account username">
                <small class="form-text text-muted">The username of your FTP account</small>
              </div>
              <div class="form-group">
                <label>Password</label>
                <input v-model="ftpFormPassword" type="password" class="form-control" placeholder="The password of your FTP account">
              </div>
              <div class="form-group">
                <label>Browsing Directory</label>
                <input v-model="ftpFormDirectory" type="text" class="form-control" placeholder="The file container directory">
                <small class="form-text text-muted">The directory which contains the files that you wish to download (EX: /tmp/)</small>
              </div>
              <button type="submit" class="btn btn-primary" @click.prevent="ftpConnect()">Connect</button>
            </form>
            <br />
          </div>
        </b-col>
      </b-row>

       <b-row v-if="canOpenS3Dialog === false">
        <b-col cols="6" class="text-center text-light bg-dark">
          <div>
            <table class="table-striped">
              <thead>
                <tr>
                  <th scope="col" class="text-center"><u>Folder Name</u></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="folder in ftpDirectoryList" v-bind:key="folder">
                  <td>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder" viewBox="0 0 16 16">
                      <path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4H2.19zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"/>
                    </svg>
                  </td>
                  <td class="">
                    <span style="cursor: pointer;" @click.prevent="navigateS3Folder(folder)">
                      {{ folder }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
        <b-col cols="6" class="text-center text-light bg-dark">
          <div>
            <table class="table-striped">
              <thead>
                <tr>
                  <th scope="col" class="text-center"><u>File Name</u></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="file in s3FileList" v-bind:key="file">
                  <td class="text-left">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-code" viewBox="0 0 16 16">
                      <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>
                      <path d="M8.646 6.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 9 8.646 7.354a.5.5 0 0 1 0-.708zm-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 9l1.647-1.646a.5.5 0 0 0 0-.708z"/>
                    </svg>
                    <span style="cursor: pointer;" @click.prevent="downloadS3File(file)">
                      {{ file }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="canOpenS3Dialog === true">
        <b-col cols="3" class="text-center text-light bg-dark">
          <div>
            <br />
            <form>
              <div class="form-group">
                <label>S3 Access Key</label>
                <input v-model="s3FormAccessKey" type="text" class="form-control" placeholder="Enter S3 Access Key">
                <small class="form-text text-muted">Your S3 Access Key</small>
              </div>
              <div class="form-group">
                <label>S3 Secret Key</label>
                <input v-model="s3FormSecretKey" type="password" class="form-control" placeholder="Enter S3 Secret Key">
                <small class="form-text text-muted">Your S3 Secret Key</small>
              </div>
              <div class="form-group">
                <label>S3 Bucket Name</label>
                <input v-model="s3FormBucket" type="text" class="form-control" placeholder="Enter S3 Bucket Name">
                <small class="form-text text-muted">Your S3 Bucket Name (<b>**PS: The bucket & bucket's contents should be public for this utility to function correctly.</b>)</small>
              </div>
              <button type="submit" class="btn btn-primary" @click.prevent="s3Connect()">Connect</button>
            </form>
            <br />
          </div>
        </b-col>
      </b-row>

<TranscribeTasks></TranscribeTasks>

    </div>
</template>

<script>
import dropzone from 'vue2-dropzone'
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TranscribeTasks from '@/views/TranscribeTasks.vue'
import Multiselect from 'vue-multiselect'
import { v4 as uuidv4 } from 'uuid'
import apiClient from '@/services/api_client_saas.js'
import apiClientBlob from '@/services/api_client_saas_blob.js'

export default {
  name: 'app',
  components: {
    vueDropzone: dropzone,
    TranscribeTasks,
    Multiselect
  },
  data: () => {
    return {
      filesAdded: 0,
      canOpenFTPDialog: null,
      ftpFormUsername: null,
      ftpFormPassword: null,
      ftpFormDirectory: null,
      ftpFormHost: null,
      ftpFileList: null,
      ftpDirectoryList: null,
      canOpenS3Dialog: null,
      s3FormAccessKey: null,
      s3FormSecretKey: null,
      s3FormBucket: null,
      s3FileList: null,
      s3FormDirectory: null,
      lexiconListGenerated: false,
      transcribeModel: null, //
      transcribeLexiconId: null,
      transcribeLexiconModels: [],
      selectedOptions: [],
      alertType: 'warning',
      alertVisible: false,
      alertText: '',
      helpVisible: false,
      options: [
        {
          name: 'punc',
          label: 'Punctuation'
        },
        {
          name: 'diar',
          label: 'Speaker diarization'
        }
      ]
    }
  },
  mounted: function () {
    this.selectedOptions = this.options
  },
  computed: {
    ...mapGetters([
      'transcribeModels',
      'defaultApiKey'
    ]),
    authTokenCookie () {
      return Vue.$cookies.get(process.env.VUE_APP_AUTH_COOKIE_NAME)
    },
    selectedModel () {
      return (this.transcribeModel) ? this.transcribeModel.name : ''
    },
    disabledUploadButton () {
      return !this.transcribeModel
    },
    // droppedFileCount () {
    //   if (this.$refs.myVueDropzone) {
    //     return this.$refs.myVueDropzone.dropzone.files.length
    //   }
    //   return 0
    // },
    // filesAdded () {
    //   return this.$refs.myVueDropzone.dropzone.files.length
    // },
    dropzoneOptions () {
      return {
        autoProcessQueue: false,
        acceptedFiles: '.mp3, .ogg, .flac, .wav, .m4a, .mp4, .aac',
        addRemoveLinks: true,
        url: `${process.env.VUE_APP_LANGUAGE_API_BASE_URL}/urls/echo`,
        maxFilesize: 10000, // 10 GB
        headers: {
          'x-user-id': this.userId,
          'x-session-id': this.$store.state.sessionId,
          'x-auth-token': this.authTokenCookie,
          api_key: null
        },
        parallelUploads: 100,
        uploadMultiple: false,
        dictDefaultMessage: 'Upload your .mp3, .ogg, .flac, .wav, .aac or .mp4 file(s)',
        timeout: 1800000 // times out after 30 minutes (Removing this option might cause the upload process to get timed out, more info can be found here => https://www.dropzonejs.com/#config-timeout)
      }
    },
    awss3 () {
      return {
        signingURL: (f) => {
          var id = uuidv4()
          const tempTask = {
            id: id,
            service: 'transcribe',
            created_at: new Date().toISOString(),
            api_status: 'presigning',
            api_progress: 0,
            original_filename: f.name,
            source_lang: this.selectedModel,
            process_time_ms: 0,
            source_characters: 0,
            source_duration_sec: 0,
            upload_progress: 0
          }
          this.$store.dispatch('putTask', tempTask)
          const customVocabularyId = this.transcribeLexiconId ? this.transcribeLexiconId.split(' => ')[1] : ''
          return `${process.env.VUE_APP_LANGUAGE_API_BASE_URL}/urls/post/` + f.name + '?id=' + id + '&custom_vocabulary_id=' + customVocabularyId
        }, // Where you will get signed url
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-auth-token': this.authTokenCookie,
          'x-model': this.selectedModel,
          'x-session-id': this.$store.state.sessionId,
          'x-features': this.transcribeLexiconId ? this.selectedOptions.map(x => x.name).join(',') + ',lexicon_id=' + this.transcribeLexiconId.split(' => ')[1] : this.selectedOptions.map(x => x.name).join(','),
          'x-lexicon-model': this.transcribeLexiconId ? this.transcribeLexiconId.split(' => ')[1] : '',
          api_key: this.defaultApiKey // caveat: named api_key as opposed to x-api-key to avoid confusion with AWS
        },
        sendFileToServer: false // If you want to upload file to your server along with s3,
        // withCredentials: true <-- do NOT use this !
      }
    },
    userId () {
      var token = Vue.$cookies.get(process.env.VUE_APP_AUTH_COOKIE_NAME)
      var decoded = jwt_decode(token)
      return decoded.sub
    }
  },
  methods: {
    customLabel (option) {
      return true
    },
    fetchLexicons () {
      this.transcribeLexiconModels = []
      this.lexiconListGenerated = false
      apiClient.get('/api/lexicon/transcribe-models-list?model=' + this.transcribeModel.name).then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          this.transcribeLexiconModels.push(response.data[i][1] + ' => ' + response.data[i][0])
        }

        if (this.transcribeLexiconModels.length > 0) {
          this.lexiconListGenerated = true
        }
      })
    },
    incrementFileCount (f) {
      this.filesAdded++
    },
    decrementFileCount () {
      this.filesAdded--
    },
    openFTPDialog () {
      this.canOpenS3Dialog = null
      if (this.ftpFormUsername) {
        this.ftpFormUsername = null
        this.ftpFormPassword = null
        this.ftpFormDirectory = null
        this.ftpFormHost = null
        this.canOpenFTPDialog = false
      } else {
        this.canOpenFTPDialog = true
      }
    },
    openS3Dialog () {
      this.canOpenFTPDialog = null
      if (this.s3FormAccessKey) {
        this.s3FormAccessKey = null
        this.s3FormSecretKey = null
        this.s3FormBucket = null
        this.canOpenS3Dialog = false
      } else {
        this.canOpenS3Dialog = true
      }
    },
    downloadFtpFile (file) {
      const fileData = file.split('.')
      apiClientBlob.post('/transcribe/download-ftp-file', {
        username: this.ftpFormUsername,
        password: this.ftpFormPassword,
        targetFile: this.ftpFormDirectory + '/' + file,
        fileName: file,
        fileExt: fileData.length > 1 ? fileData[1] : null,
        host: this.ftpFormHost
      }).then((response) => {
        const blob = new Blob([response.data], { type: 'video/' + fileData[1] })
        this.$refs.myVueDropzone.dropzone.addFile(file = new File([blob], file))
        /*
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'file-download'
        link.click()
        URL.revokeObjectURL(link.href)
        */
      }).catch((error) => {
        console.log(error)
      })
    },
    downloadS3File (file) {
      const fileData = file.split('.')
      apiClientBlob.post('/transcribe/download-s3-file', {
        accessKey: this.s3FormAccessKey,
        secretKey: this.s3FormSecretKey,
        bucket: this.s3FormBucket,
        fileName: file
      }).then((response) => {
        const blob = new Blob([response.data], { type: 'video/' + fileData[1] })
        this.$refs.myVueDropzone.dropzone.addFile(file = new File([blob], file))
        // const link = document.createElement('a')
        // link.href = URL.createObjectURL(blob)
        // link.download = 'file-download'
        // link.click()
        // URL.revokeObjectURL(link.href)
      }).catch((error) => {
        console.log(error)
      })
    },
    navigateFtpFolder (folder) {
      this.ftpFormDirectory += '/' + folder
      this.ftpConnect()
    },
    navigateS3Folder (folder) {
      this.s3FormDirectory += '/' + folder
      this.s3Connect()
    },
    ftpConnect () {
      this.canOpenS3Dialog = null
      apiClient.post('/transcribe/connect-to-ftp', {
        username: this.ftpFormUsername,
        password: this.ftpFormPassword,
        directory: this.ftpFormDirectory,
        host: this.ftpFormHost
      }).then((response) => {
        this.ftpFileList = response.data.files
        this.ftpDirectoryList = response.data.dirs
        this.canOpenFTPDialog = false
      }).catch((error) => {
        console.log(error)
      })
    },
    s3Connect () {
      this.canOpenFtpDialog = null
      apiClient.post('/transcribe/connect-to-s3', {
        accessKey: this.s3FormAccessKey,
        secretKey: this.s3FormSecretKey,
        bucket: this.s3FormBucket,
        directory: this.s3FormDirectory
      }).then((response) => {
        this.s3FileList = response.data.files
        this.s3DirectoryList = response.data.dirs
        this.canOpenS3Dialog = false
      }).catch((error) => {
        console.log(error)
      })
    },
    triggerSend () {
      this.alertVisible = false
      if (this.transcribeModel === '' || typeof this.transcribeModel === 'undefined') {
        this.alertText = 'Please select the source language'
        this.alertVisible = true
        return
      }
      // validate API key early
      apiClient.get('/transcribe/validate', { headers: { api_key: this.defaultApiKey } }).then((response) => {
        this.$refs.myVueDropzone.processQueue()
      }).catch((error) => {
        this.alertType = 'danger'
        this.alertText = error.response.data.error
        this.dismissCountDown = 30
        this.alertVisible = true
      })
    },
    s3UploadError (errorMessage) {
      console.log(`Error uploading to S3: ${errorMessage}`)
    },
    s3UploadSuccess (s3ObjectLocation) {
      // s3ObjectLocation is the full URL - eg. 'http://s3.us-east-1.amazonaws.com/apptek-website-transcode-input/9b7ad5a0-fafd-4679-b6d2-84e2e0c9bfcd%2F5448d345-adaf-4b9c-9aaf-e8f6eec2c6af--en-gb.bcn.mp4'
      const key = s3ObjectLocation.split('/').slice(-1)[0]
      const taskId = key.split('%2F')[1].split('--')[0] // note the %2F since returned from Lambda
      this.$store.dispatch('updateTaskAttribute', [taskId, 'api_status', 'uploaded'])
      this.$store.dispatch('updateTaskAttribute', [taskId, 'api_progress', 100])
    },
    uploadProgress (file, progress, bytesSent) {
      const key = file.s3Signature.key // eg. "9b7ad5a0-fafd-4679-b6d2-84e2e0c9bfcd/5c29dd93-c270-4bfa-aaf8-9453c24f41f8--en-au.bcn.ogg"
      const taskId = key.split('/')[1].split('--')[0]
      this.$store.dispatch('updateTaskAttribute', [taskId, 'api_status', 'uploading'])
      this.$store.dispatch('updateTaskAttribute', [taskId, 'api_progress', Math.round(progress)])
    }
  }
}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>

</style>
